<template>
	<div class="alert" v-show="isShow">
        <div class="alert__mask"></div>
        <div class="alert__wrapper">
            <div class="alert__top">
            </div>
            <div class="alert__body">
                <div class="alert__title">{{title}}</div>
                <div class="alert__desc" v-html="desc"></div>
            </div>
            <div class="alert__footer">
                <a :href="btn.value ? btn.value : 'javascript:void(0);'" :class="'alert__btn' + btn.className" v-for="(btn, index) in bottons" :key="index" @click="cancel">{{btn.txt}}</a>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Alert',
    data () {
        return {
            isShow: false,
            resolve: '',
            reject: '',
            promise: '' // 保存promise对象
        };
    },
	props: {
		title: {
			type: String,
			default () { return '提示'; }
        },
        desc: {
			type: String,
			default () { return ''; }
        },
        bottons: {
            type: Array,
			default () { return [{
                txt: '确定',
                className: '',
                value: 'javascript:void(0);'
            }]; }
        }
	},
	methods: {
        // 确定,将promise断定为resolve状态
        confirm: function () {
          this.isShow = false;
          this.resolve('confirm');
          this.remove();
        },
        // 取消,将promise断定为reject状态
        cancel: function () {
          this.isShow = false;
          this.reject('cancel');
          this.remove();
        },
        // 弹出messageBox,并创建promise对象
        showMsgBox: function () {
          this.isShow = true;
          this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
          });
          // 返回promise对象
          return this.promise;
        },
        remove: function () {
          setTimeout(() => {
            this.destroy();
          }, 300);
        },
        destroy: function () {
          this.$destroy();
          document.body.removeChild(this.$el);
        }
    }
};
</script>

<style lang="scss">
.alert{
    &__wrapper{
        width: 3rem;
        background: #ffffff;
        border-radius: 4px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        box-shadow: 0 0 7px 1px #dedede;
    }
    &__body{
        padding: 0.2rem;
    }
    &__title{
        font-size: 0.18rem;
        color: #111a34;
        text-align: center;
        margin-bottom: 0.14rem;
    }
    &__desc{
        font-size: 0.14rem;
        color: #666f83;
    }
    &__footer{
        display: flex;
        border-top: 0.01rem solid #e2e4ea;
        align-items: center;
        justify-content: center;
    }
    &__btn{
        flex: 1;
        display: block;
        height: 0.5rem;
        line-height: 0.5rem;
        text-align: center;
        font-size: 0.16rem;
        color: #2f86f6;
        text-decoration: none;
    }
}
</style>
